
const ContactUsPage = () => {
    return (
        <>

            <p className="text-center">Have a question? We'd love to hear from you!</p>

            <div class="m-auto text-center">
                <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLScDDQ8vvkROrg0HtCuVEM5Ct0swxHASzJGFIXn1bPHw2zOnQA/viewform?embedded=true"
                    width="100%" height="800">Loading…</iframe>
            </div>

        </>
    )
};

export default ContactUsPage;